<div>
    <h2 i18n>Select language</h2>
    <ol>
        <li><a href="{{url}}/cs/" >Čeština</a></li>
        <li><a href="{{url}}/da/" >Danish</a></li>
        <li><a href="{{url}}/de/" >Deutsch</a></li>
        <li><a href="{{url}}/en/" >English</a></li>
        <li><a href="{{url}}/es/" >Español</a></li>
        <li><a href="{{url}}/fr/" >Français</a></li>
        <li><a href="{{url}}/hu/" >Magyar</a></li>
        <li><a href="{{url}}/nb/" >Norsk</a></li>
        <li><a href="{{url}}/sk/" >Slovenský</a></li>
        <li><a href="{{url}}/sv/" >Svenska</a></li>
    </ol>
</div>